import type { ArticleParagraphComponent } from '@twisto/api-cms'

import type { RichTextBlock } from 'homepage/components/rich-text/rich-text.d'

import { RichText } from '../../rich-text'

import * as styles from './paragraph.styles'

type ParagraphProps = ArticleParagraphComponent & { text?: RichTextBlock[] }

export const Paragraph = ({ text }: ParagraphProps) => (
  <RichText css={styles.paragraph} input={text} />
)
